define('components/factory/models/MultiMediasModel', [

], function() {

    var MultiMediasModel = Backbone.Model.extend({
        defaults: {
            viewId: "multimedias-id",       // Classic default viewId
            customClass: "",                // Custom css class to add to global div
            title: "",                      // Title of the view. If empty -> hidden
            subtitle: "",                   // Subtitle of the view. If empty -> hidden
            mediasGroup: [],                // All medias of the view
                                            // mediasGroup
                                            // -> className
                                            // -> link ( optional )
                                            // -> medias // Only one per media
                                            // -> -> className
                                            // -> -> link ( optional )
                                            // -> -> image ( + share, + legende )
                                            // -> -> videoproduct
                                            // -> -> video
                                            // -> -> text
                                            // -> -> html
                                            // -> -> button
                                            // -> -> product
                                            // -> -> share
            autoplayVideoOnScroll: true,    // Autoplay/pause video when video enter/leave screen
            isReady: false                  // Classic isReady
        }
    });

    return MultiMediasModel;
});
